import { compareAsc, differenceInCalendarDays, format } from 'date-fns'
import { IEvent, IGuestInfo } from '../index'
import {
  ICreateReservationFormValues,
  IFormService,
} from '../../../containers/Form/CreateReservation/CreateReservation'
import store from '../../../store'
import dateFormat, { timeFormat } from '../../../utils/DateFormat'
import { mapItemToPrice } from '../../../utils/Money'

export default function(event: IEvent): ICreateReservationFormValues {
  const formatDate = store.getState().object.userObject.settings.dateFormat
  function mapChildren(kidsAge, kids) {
    return kidsAge && Array.isArray(kidsAge) //In case Api returns object
      ? kidsAge.map(age => ({ age: +age })).slice(0, kids)
      : Array(kids).fill({ age: 0 })
  }

  function mapServices(services): IFormService[] {
    return services
      ? services.map(service => ({
          count: 1,
          id: service.id,
          name: service.service_name,
          price: Number(service.price)
            .toFixed(2)
            .replace(',', '.'),
          secondTax: service.second_tax,
          tax: service.first_tax,
        }))
      : undefined
  }

  function mapRoomMates(roomMates) {
    return roomMates
      ? roomMates.map(
          mate =>
            ({
              apartmentNumber: mate.local_number,
              city: mate.city,
              country: mate.nationality,
              email: mate.email,
              houseNumber: mate.street_number,
              idCard: mate.id_card,
              name: mate.client_name,
              passport: mate.passport,
              phone: mate.phone,
              postCode: mate.post_code,
              street: mate.street,
            } as IGuestInfo),
        )
      : undefined
  }

  const timeToPayDate = event.dateToPay
  const timeToWaitDate = event.dateToPayAfterStart

  return event
    ? {
        additionalGuests: mapRoomMates(event.roomMates),
        adultsCount: event.adults,
        advancePaymentPrice: event.provision
          ? mapItemToPrice(event.provision).toFormat()
          : undefined,
        advancePaymentType: event.provisionMethod,
        advancePriceDate: event.provisionDate,
        children: mapChildren(event.kidsAge, event.kids),
        childrenCount: event.kids,
        company: event.company
          ? {
              city: event.company.city,
              country: event.company.country,
              name: event.company.name,
              postCode: event.company.postCode,
              street: event.company.street,
              vatId: event.company.vatId,
            }
          : undefined,
        createDate: format(event.createdAt, dateFormat(formatDate.date, '')),
        customColor: event.customColor
          ? event.customColor.toString()
          : undefined,
        dateFrom: event.startDate,
        dateTo: event.finishDate,
        daysCount: differenceInCalendarDays(event.finishDate, event.startDate),
        deposit: event.deposit
          ? mapItemToPrice(event.deposit).toFormat()
          : undefined,
        doorCode: event.doorCode,
        endPrice: event.price
          ? mapItemToPrice(event.price).toFormat()
          : undefined,
        feeding: event.service,
        guest: event.guest
          ? ({
              apartmentNumber: event.guest.apartmentNumber,
              city: event.guest.city,
              country: event.guest.country,
              email: event.guest.email,
              houseNumber: event.guest.houseNumber,
              idCard: event.guest.idCard,
              name: event.guest.name,
              passport: event.guest.passport,
              phone: event.guest.phone,
              postCode: event.guest.postCode,
              street: event.guest.street,
            } as IGuestInfo)
          : undefined,

        localTax: event.localTax
          ? mapItemToPrice(event.localTax).toFormat()
          : undefined,
        note: event.notes,
        payOnPlaceDate: event.paymentOnPlaceDate,
        payOnPlacePaymentType: event.paymentOnPlaceMethod,
        payOnPlacePrice:
          event.price && event.provision
            ? mapItemToPrice(event.price)
                .subtract(mapItemToPrice(event.provision))
                .toFormat()
            : undefined,
        prepaidType: event.prepaidType,
        prepaymentType: event.prepaidType,
        pricePerDay: event.pricePerDay
          ? mapItemToPrice(event.pricePerDay).toFormat()
          : undefined,
        priceType: event.priceType,
        provenances: event.provenance,
        registration: event.registration,
        reservationStatus: event.stage,
        roomId: event.roomId,
        services: mapServices(event.additionalServices),
        setCustomColor: Boolean(event.customColor),
        singleBeds: event.singleBed ? Number(event.singleBed) : undefined,
        timeFrom: event.arrivalTime
          ? format(event.arrivalTime, timeFormat('GG:mm'))
          : undefined,
        timeTo: event.departureTime
          ? format(event.departureTime, timeFormat('GG:mm'))
          : undefined,
        timeToPayDate: timeToPayDate,
        timeToPayDays: timeToPayDate
          ? compareAsc(timeToPayDate, new Date()) !== -1
            ? differenceInCalendarDays(timeToPayDate, new Date())
            : undefined
          : undefined,
        timeToWaitDate: timeToWaitDate,
        timeToWaitDays: timeToWaitDate
          ? compareAsc(timeToWaitDate, new Date()) !== -1
            ? differenceInCalendarDays(timeToWaitDate, new Date())
            : undefined
          : undefined,
        twinBeds: event.doubleBed ? Number(event.doubleBed) : undefined,
        withoutTax: event.localTaxIncluded,
      }
    : null
}
